"use strict";

PF.Field.TreeMultiSelect = class TreeMultiSelect extends PF.Field {
    static get options() {
        return {
            html: PF.Field.TreeMultiSelect.templates,
            popupConfig: {
                title: 'Выберите значения'
            },

            label: "Выберите значения",
            model: new PF.Model({}),
            key: 'value',
            searchLabel: 'Поиск',

            showInfo: true,
            helper: '',

            listTitle: (count) => `${Util.spell(count, ['Выберите значения', 'Выбрано @{v} значение', 'Выбрано @{v} значения', 'Выбрано @{v} значений'])}`,
            simpleTitle: (count) => `Выбрано ${Util.spell(count, ['', '@{v} значение', '@{v} значения', '@{v} значений'])}`,

            includeRoot: true,
            typeKey: '#table',

            types: {
                root: {
                    id: 'root',
                    childs: [],
                    childListConfig: {
                        enableDummy: true,
                    }
                },
            },
            defaultItemClass: PF.Field.TreeMultiSelect.Item,
            errors: {}
        };
    }

    static get templates() {
        return {
            //language=HTML
            wrapper: `
				<div class="pf-select-wrapper">
					<div class="pf-select" pf="select">
						<div class="pf-select-label" pf="label"></div>
						<div class="pf-selected" pf="selected">&nbsp;</div>

					</div>
					<div class="underline">
						<hr class="normal"/>
						<hr class="focus"/>
					</div>
					<div class="info" pf="info">&nbsp;</div>
				</div>
			`,
            //language=HTML
            selectInner: `
				<div class="item-inner">
					<div class="item-title" pf="simpleTitle">
						@{simpleTitleText}
					</div>
				</div>`,
            //language=HTML
            popupContent: `
				<div class="pf-tree-multi-select-popup-content">
					<div class="pf-list-crud-header" pf="header">

						<div class="title-row" pf="titleRow">
							<div class="title" pf="title"></div>
							<div class="search-box" pf="searchBox">
								<input type="text" pf="search"/>
							</div>
						</div>
						<div class="actions">
							<a class="link" style="display: none" class="search-toggle" pf="searchToggle"><i class="material-icons">search</i></a>
						</div>
					</div>
					<div class="pf-tree list" style="margin-top: 0;" pf="tree">
					</div>
                    <div class="block">
                        <a href="#" class="button button-raised" pf="selectOk">ОК</a>
                    </div>
				</div>
			`,
            //language=HTML
            rootList: `
				<ul></ul>`,
        };
    }


    init() {
        this.dom.loads(this.html);
        this.dom.element.append(this.dom.wrapper);

        this.popup = new PF.F7Popup({
            dom: { content: this.dom.popupContent },
            ...this.popupConfig
        });
        this.dom.select.on('click', () => this.popup.open());

        this.hash = PF.H.hash(this.types);
        this.states = JSON.parse(window.localStorage.getItem(this.hash)) || {};
        this.onFinish('changeOpenStates', () => {
            this.states = this.root.collectStates(this.states);
            window.localStorage.setItem(this.hash, JSON.stringify(this.states));
        }, 100);

        this.nodeMap = {};

        for (let type in this.types) {
            if (this.types[type].selectable === true) {
                let key = this.types[type].key;
                let modelsConfig = this.get(`types.${type}.modelsConfig`, {}, {});
                if (this.model.get(key, null, null) === null) {
                    this.model.setData(key, new PF.Models({ parent: this.model, ...modelsConfig }), true);
                } else {
                    PF.Options.assignOptions(this.model.get(key), modelsConfig);
                }
            }
        }

        this.root = PF.H.create(this.types.root.itemClass || this.defaultItemClass, { list: null, tree: this, parent: null, ...this.types.root, model: this.types.root.model }, );
        this.root.render();
        this.dom.rootList.append(this.root.dom.item);
        this.bindDom({ tree: 'content' }, 'includeRoot', (i) => {
            return i === true ? this.dom.rootList : this.root.dom.childsList;
        });


        this.countSelected = 0;
        for (let type in this.types) {
            if (this.types[type].selectable === true) {
                let key = this.types[type].key;
                this.model.get(key).on(['changed', 'childs-changed'], () => {
                    this.setSelectedStates();
                    this.validate(true);
                    this.calcCountSelected();
                }, true);
            }
        }


        this.calc('popup.title', `countSelected`, (c) => this.listTitle(c));
        this.calc('simpleTitleText', `countSelected`, (c) => this.simpleTitle(c));
        this.dom.load(this.html.selectInner, 'selectInner');
        this.dom.selectInner.bindObject(this);
        
		this.dom.selectOk.on("click", () => this.popup.close());

        this.bindDom({ wrapper: 'class:error' }, 'error', (e) => e !== '');
        this.bindDom({ wrapper: 'class:focus' }, 'popup.opened');
        this.bindDom({ info: 'html' }, ['helper', 'error'], (h, e) => e !== '' ? e : h !== '' ? h : '&nbsp;');
        this.bindDom({ info: 'show' }, 'showInfo');
        this.bindDom({ label: 'html' }, 'label');
        this.bindDom({ select: 'class:active' }, 'countSelected', (c) => c > 0);
        this.bindDom({ selected: 'content' }, 'countSelected', (c) => c === 0 ? '&nbsp;' : this.dom.selectInner);

        this.initSearch();
    }

    initSearch() {
        this.dom.searchToggle.show();
        this.searchString = new PF.Field.String({
            dom: {
                element: this.dom.search
            },
            key: 'value',
            model: new PF.Model({ raw: { value: '' } }),
            label: this.searchLabel,
            showInfo: false
        });

        this.searchShow = true;
        this.dom.searchToggle.on('click', () => this.searchShow = !this.searchShow);
        this.bindDom({ searchToggle: 'class:active', titleRow: 'class:search-show' }, 'searchShow');

        this.onValue('searchShow', true, () => this.searchString.setFocus());
        this.onValue('searchShow', false, () => this.searchString.model.value = '');

        this.onChange('searchString.model.value', () => {
            this.searchValue = this.searchString.model.get('value');
            this.root.searchValue = this.searchValue;
        });
    }

    calcCountSelected() {
        let countSelected = 0;
        for (let type in this.types) {
            if (this.types[type].selectable === true) {
                let key = this.types[type].key;
                countSelected += this.model.get(key).notRemovedCount;
            }
        }
        this.countSelected = countSelected;
    }

    setSelectedStates() {
        for (let type in this.types) {
            if (this.types[type].selectable === true) {
                let key = this.types[type].key;
                let models = this.model.get(key);
                for (let i = 0; i < models.length; i++) {
                    let node = this.nodeMap[models[i].get(models.idIndex)];
                    if (node !== undefined) {
                        models[i].populateData(node.model);
                        if (models[i].options.removed !== true) {
                            node.selectState = true;
                        } else {
                            node.selectState = false;
                        }
                    }
                }
            }
        }
    }

    findItemByModel(model) {
        return this.root.childsList.findItemByModel(model);
    }

    validate(silent, error = undefined) {
        if (this.required === true) {
            if (this.model.get(this.key, null, null) === null) {
                return super.validate(silent, this.errors.required);
            }
        }
        return super.validate(silent, error);
    }

};


PF.Field.TreeMultiSelect.Item = class Item extends PF.List.Item {
    static get options() {
        return {
            html: PF.Field.TreeMultiSelect.Item.templates,
            selectable: false,
            childListConfig: { search: '@{name}', modelsConfig: { loadOnInit: false, filterDebounceMethod: 'onFinish' } },
            simpleName: '@{model.name}',
            childsKey: undefined,
            selectState: false,
        };
    }

    get renderer() {
        //language=HTML
        return `
			<li class="accordion-item pt-tree-multi-select-node" pf="item">
				<div class="pf-tree-body" pf="body">

				</div>
				<div class="accordion-item-content">
					<div class="list" pf="childsList">
						<div pf="childs">
						</div>
					</div>
				</div>
			</li>
		`;
    }

    static get templates() {
        return {
            body: [{
                    selectable: true,
                    expandable: true,
                    //language=HTML
                    template: `
						<div class="pf-tree-body-content" pf="bodyContent">
							<label class="item-checkbox checkbox expandable" pf="label" for="null">
								<input type="checkbox" pf="input"/>
								<i class="icon icon-checkbox"></i>
							</label>
							<a href="#" class="item-content item-link pf-accordion-link" pf="openLink">
								<div class="itemInnerContainer" pf="itemInnerContainer"></div>
							</a>
						</div>
					`,
                },
                {
                    selectable: true,
                    expandable: false,
                    //language=HTML
                    template: `
						<div class="pf-tree-body-content" pf="bodyContent">
							<label class="item-checkbox label-body" pf="label">
								<input type="checkbox" pf="input"/>
								<i class="icon icon-checkbox"></i>
								<div class="itemInnerContainer" pf="itemInnerContainer"></div>
							</label>
						</div>
					`,
                },
                {
                    selectable: false,
                    expandable: true,
                    //language=HTML
                    template: `
						<div class="pf-tree-body-content" pf="bodyContent">
							<label class="item-radio checkbox expandable" pf="label" for="null">
								<input type="checkbox" pf="input"/>
								<i class="icon icon-checkbox"></i>
							</label>
							<a href="#" class="item-content item-link pf-accordion-link" pf="openLink">
								<div class="itemInnerContainer" pf="itemInnerContainer"></div>
							</a>
						</div>
					`,
                },
                {
                    selectable: false,
                    expandable: false,
                    //language=HTML
                    template: `
						<div class="pf-tree-body-content " pf="bodyContent">
							<div class="item-content">
								<div class="itemInnerContainer" pf="itemInnerContainer"></div>
							</div>
						</div>
					`,
                }
            ]
        };
    }

    get bodyTemplate() {
        for (let i = 0; i < this.html.body.length; i++) {
            if (this.html.body[i].selectable === this.selectable && this.html.body[i].expandable === this.expandable) {
                return this.html.body[i].template;
            }
        }
    }

    get itemInner() {
        //language=HTML
        return `
			<div class="item-inner">
				<div class="item-title">
					@{simpleName}
				</div>
			</div>`;
    }

    init() {
        this.dom.loads(this.html);

        this.displayLength = 0;
        this.selectLength = 0;
        this.markLength = 0;
        this.markLengthPart = 0;
        this.selectable = this.model.isNull() === true ? true : this.selectable;

        if (this.parent !== null) {
            this.tree.nodeMap[this.model.get(this.list.models.idIndex)] = this;
        }
    }

    render() {
        this.dom.load(this.renderer);
        this.onRender({});
    }

    printStates() {
        console.log(this.model.name || this.model.address || this.model.number, 'selectState:', this.selectState, 'markState:', this.markState, "selectLength:", this.selectLength, 'markLength:', this.markLength, 'markLengthPart', this.markLengthPart);
        for (let i = 0; i < this.childsList.length; i++) {
            this.childsList[i].printStates();
        }
    }

    onRender(event) {
        super.onRender(event);

        // if (this.dict !== undefined)
        // 	{
        // 	this.listConfig.modelsConfig.raw = this.model.options.dicts[this.dict].toJSON();
        // 	}

        this.childListConfig.modelsConfig.parent = this.model;
        this.childsList = new PF.Field.TreeMultiSelect.List({
            dom: { element: this.dom.childs },
            parent: this,
            tree: this.tree,
            models: this.model.get(this.childsKey),
            ...this.childListConfig
        });
        this.childsList.models.loadCount();
        this.childsList.models.on('load-part', () => this.tree.trigger('childs-changed'));
        this.childsList.models.filter.and(`(${this.childListConfig.search} ~ @{list.parent.searchValue})`, 'l');

        this.calc('searchValue', ['model.options.filterShow', 'tree.searchValue'], (s, v) => {
            if (v === undefined) {
                return '';
            }
            this.childsList.models.loadPart();
            if (s === false) {
                this.openState = true;
            }
            return s === false ? v : '';
        });
        this.calc('displayState', ['model.options.filterShow', 'displayLength'], (f, l) => {
            return f || l > 0;
        });

        this.calc('expandable', ['childsList.models.dataStatus', 'displayLength', 'childsList.models.count'], (s, d, c) => s === 'notLoaded' ? c > 0 : d > 0);


        this.onChange('openState', () => this.tree.trigger('changeOpenStates'));
        this.onValue('openState', true, () => {
            if (this.childsList.models.dataStatus !== 'allLoaded') {
                this.childsList.models.loadPart();
            }
        });
        this.onValue('openState', false, () => this.goDownState('openState', false));

        if (this.selectable === true) {
            this.onValue('selectState', true, () => this.tree.model.get(this.key).addModel(this.model), false);
            this.onValue('selectState', false, () => this.tree.model.get(this.key).removeModel(this.model), false);
        }
        this.onChange(['selectLength'], () => this.selectState = this.selectLength === this.childsList.models.notRemovedCount);

        this.calc('markState', ['markLength', 'markLengthPart', 'selectState'], (markLength, markLengthPart, selectState) => {
            // return selectState === true ? 'selected' : (selectLength > 0 ? (selectLength === this.childsList.models.notRemovedCount ? 'selected' : 'part') : 'notSelected');
            if (selectState === true) {
                return 'selected';
            }
            if (markLength > 0 || markLengthPart > 0) {
                if (markLength === this.childsList.models.notRemovedCount) {
                    return 'selected';
                }
                return 'partSelected';
            }
            return 'notSelected';
        });


        if (this.parent !== null) {
            this.onValue('displayState', true, () => this.parent.displayLength++, );
            this.onValue('displayState', false, () => this.parent.displayLength--, );

            this.onValue('selectState', true, () => this.parent.selectLength++, false);
            this.onValue('selectState', false, () => this.parent.selectLength--, false);

            this.on('beforeChange:markState', (oldValue, newValue) => {
                if (oldValue !== "selected" && newValue === "selected") {
                    this.parent.markLength++;
                }
                if (oldValue === "selected" && newValue !== "selected") {
                    this.parent.markLength--;
                }
                if (oldValue !== 'partSelected' && newValue === 'partSelected') {
                    this.parent.markLengthPart++;
                }
                if (oldValue === 'partSelected' && newValue !== 'partSelected') {
                    this.parent.markLengthPart--;
                }
            });
        }

        this.onChange(['selectable', 'expandable'], () => this.setupBody(), true);
    }

    bindDomFilter() {
        this.bindDom({ item: 'show' }, 'displayState');
    }

    setupBody() {
        this.dom.body.empty();
        this.dom.load(this.bodyTemplate, 'bodyContent');
        this.dom.body.append(this.dom.bodyContent);
        this.dom.load(this.itemInner, 'itemInner');
        this.dom.itemInnerContainer.append(this.dom.itemInner);
        this.dom.body.bindObject(this);

        if (this.expandable === true) {
            this.bindDom({ item: 'class:accordion-item-opened' }, 'openState');
            this.dom.openLink.on('click', (event) => {
                event.stopPropagation();
                this.openState = !this.openState;
            });
            this.dom.label.on('click', () => {
                this.selectAll(this.markState === "notSelected");
            });
        }
        if (this.expandable === true || this.selectable === true) {
            this.dom.input.on('click', () => {
                this.selectState = !this.selectState;
            });
            this.dom.label.bindClasses();
            this.calc('dom.label.classes.state', 'markState');
        }

        this.openState = PF.H.get(this.tree.states, this.model.get('id'), false, false);
    }

    selectAll(select) {
        if (this.childsList.models.dataStatus !== 'allLoaded') {
            this.childsList.models.onValueOnce('dataStatus', 'allLoaded', () => this.selectAll(select));
            this.childsList.models.loadPart();
            return;
        }

        for (let i = 0; i < this.childsList.length; i++) {
            this.childsList[i].selectAll(select);
            if (this.childsList[i].selectable === true) {
                this.childsList[i].selectState = select;
            }
        }
    }


    goDownState(state, value, own = true) {
        if (own) {
            PF.H.set(this, state, value);
        }
        for (let i = 0; i < this.childsList.length; i++) {
            this.childsList[i].goDownState(state, value);
        }
    }

    collectStates(states = {}) {
        states[this.model.get('id', 'undefinedIdentifier', 'undefinedIdentifier')] = this.openState;
        for (let i = 0; i < this.childsList.length; i++) {
            this.childsList[i].collectStates(states);
        }
        return states;
    }

    destroy() {
        this.tree.nodeMap[this.model.get(this.list.models.idIndex)] = undefined;
        super.destroy();

        this.childsList.destroy();
        this.childsList = undefined;
        if (this.parent !== null && this.displayState === true) {
            this.parent.displayLength--;
        }
    }
};

PF.Field.TreeMultiSelect.List = class TreeMultiSelectList extends PF.List {
    static get options() {
        return {
            searchable: false,
            enableDummy: false,
            enableHeader: false,
        };
    }

    init() {
        super.init();
        this.bindDom({ wrapper: 'class:pf-root-wrapper' }, 'parent.parent', (p) => p === null);
    }

    create(model) {
        let type = model.get(this.tree.typeKey);
        let config = this.tree.types[type];
        let itemClass = PF.H.get(config, 'itemClass', this.tree.defaultItemClass, this.tree.defaultItemClass);
        return PF.H.create(itemClass, { list: this, model: model, tree: this.tree, parent: this.parent, type: type, ...config });
    }

    findItemByModel(model) {
        for (let i = 0; i < this.length; i++) {
            if (PF.H.compareByPks(model, this[i].model)) {
                return this[i];
            }
            let item = this[i].childsList.findItemByModel(model);
            if (item !== this.tree.nullItem) {
                return item;
            }
        }
        return this.tree.nullItem;



    }

};